import * as React from "react";
import { scrollSelectionIntoView } from "../../../messageBoard";

export const useIsOpened = () => {
    const [, forceRerender] = React.useState(1);
    const isOpened = React.useRef(false);
    const onOpen = () => {
        isOpened.current = true;
        // for case when user press mention button but current selection is outside of viewport
        requestAnimationFrame(() => scrollSelectionIntoView());
        forceRerender(v => v + 1); // important to get working useSuggestions hook
    };

    const onClose = () => {
        isOpened.current = false;
        forceRerender(v => v + 1); // important to get working useSuggestions hook
    };

    return { isOpened, onOpen, onClose } as const;
};
